import React from 'react';
import * as ActionTypes from '../../constants/ActionTypes';
import {
    availableFontSizes,
    availableFontStyle,
    availableTextAlign,
    availableTextDecoration,
    availableLineHeight,
    availableBorderStyle,
    availableBorderWidth
} from '../../constants/availableFonts';

const headerStoreDefaults = {
    availableFontSizes: availableFontSizes,
    availableFontStyle: availableFontStyle,
    availableTextDecoration: availableTextDecoration,
    availableLineHeight: availableLineHeight,
    availableTextAlign: availableTextAlign,
    availableBorderStyle: availableBorderStyle,
    availableBorderWidth: availableBorderWidth
};

const headerReducer = (state = headerStoreDefaults, action) => {
    return state;
};

export default headerReducer;



// WEBPACK FOOTER //
// ./src/reducers/theme/header.js